import './pigsonwheels/style';
import FormStructure from './pigsonwheels/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js